module.exports = __webpack_public_path__ + "img/COMPREHENSIVE.b0e3f70b.png";